import { on } from 'delegated-events';
import showPopup from './modals';

export default function () {
    const newsletter = document.getElementById('newsletter');
    if (!newsletter) return;
    const formContainer = newsletter.querySelector('.form-container');
  
    const pageType = document.querySelector("body").dataset.type;
    
    const isPopupType = (pageType == 'detail');
    if (isPopupType) initPopup();

    initForm();

    function initForm() {
        const form = document.getElementById('newsletter-form');

        
        const email = document.getElementById('n-email');
        const privacy = document.getElementById('n-privacy');
        const telemetry = document.getElementById('n-telemetry');

        const button = document.getElementById('newsletter-send');

        validateForm();
       
        [email, privacy, telemetry].forEach(el => {
            el.addEventListener('input', validateForm);
            el.addEventListener('change', validateForm);
        });

        function validateForm() {
            if (
                (email.value.trim().length < 2)
                || (!privacy.checked)
                || (!telemetry.checked)) {
                return button.disabled = true;
            }
            return button.disabled = false;
        }


        form.addEventListener('submit', (e) => {

            e.preventDefault();



            var email = form["email"].value;

            fetch('/api/frontend/newsletter', {
                method: 'POST',
                credentials: 'same-origin',
                body: JSON.stringify({
                    email: email,
                    recaptcha: ''
                }),
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            })
                .then(response => response.json())
                .then(data => {
                    showPopup({ body: (data && data.message) ? data.message : form.getAttribute("data-confirm") });
                })
                .catch(() => {
                    showPopup({ body: form.getAttribute("data-confirm") });
                });

            form.reset();
            validateForm();
            if (isPopupType) newsletter.querySelector('dialog').close();
        });
    }


    function initPopup() {
        newsletter.classList.add('popup-type');
        const modal = document.createElement('dialog');
        const side = document.querySelector('.newsletter-side');

        const header = newsletter.querySelector('.newsletter-header').cloneNode(true);
        if (header) side.prepend(header);

        modal.innerHTML += formContainer.innerHTML;
        formContainer.remove();
        newsletter.appendChild(modal);

        on('click', '[data-action="newsletter-popup"]', function () {
            modal.showModal();

            if (typeof exponea !== 'undefined') {


                exponea.track('banner', {

                    action: 'show',
                    banner_id: 'newsletter_popup',
                    banner_name: 'newsletter',
                    location: window.location.href,
                    path: window.location.pathname

                });



            };
        });


        const closeButton = modal.querySelector('[value="close"]');
        modal.addEventListener('click', (e) => {
            if (e && (e.target === modal) || (e.target === closeButton)) {

                exponea.track('banner', {

                    action: 'close',
                    banner_id: 'newsletter_popup',
                    banner_name: 'newsletter',
                    location: window.location.href,
                    path: window.location.pathname

                });
                modal.close();


            }
        });
    }


}